import * as Yup from 'yup';
import { testPhoneNumbervalue } from '../global/helper';

export interface CreateCustomerValues {
  firstName: string;
  phoneNumber: string;
  lastName?: string;
  email?: string;
  dob?: string;
  internalNotes?: string;
}

export const initFormValues: CreateCustomerValues = {
  firstName: '',
  lastName: '',
  email: '',
  phoneNumber: '',
  dob: '',
  internalNotes: '',
};

export const validationSchema = Yup.object().shape({
  firstName: Yup.string().required('First name is required'),
  phoneNumber: Yup.string()
    .test({
      test: testPhoneNumbervalue,
      message: 'Invalid phone number',
    })
    .required('Phone number is required'),
  lastName: Yup.string(),
  email: Yup.string().email(),
  dob: Yup.date(),
  internalNotes: Yup.string(),
});
